import { DetectedPattern } from '../../types';
import { Check } from 'lucide-react';

interface PatternCardProps {
    pattern: DetectedPattern;
    onAcknowledge: () => void;
    onResolve: () => void;
    onClick: () => void;
}

export function PatternCard({ pattern, onAcknowledge, onResolve, onClick }: PatternCardProps) {
    return (
        <div
            className="bg-white rounded-lg shadow-sm border p-4 hover:shadow-md transition-shadow cursor-pointer"
            onClick={onClick}
        >
            <div className="flex items-start justify-between">
                <div className="flex items-center gap-2 flex-1 min-w-0">
                    <span className="text-xl">{pattern.severity_icon}</span>
                    <div className="flex-1 min-w-0">
                        <h3 className="font-medium text-gray-900 truncate">{pattern.title}</h3>
                        <p className="text-sm text-gray-500">{pattern.stats.lift_label}</p>
                    </div>
                </div>
                <div className="text-right ml-4">
                    <div className="text-lg font-bold text-red-600">
                        ${pattern.impact.estimated_monthly_loss.toLocaleString()}
                    </div>
                    <div className="text-xs text-gray-500">monthly loss</div>
                </div>
            </div>

            <p className="mt-3 text-sm text-gray-600 line-clamp-2">
                {pattern.description}
            </p>

            <div className="mt-4 flex items-center justify-between gap-2">
                <div className="flex items-center gap-4 text-xs text-gray-500">
                    <span>{pattern.stats.affected_payments} payments affected</span>
                    <span>{pattern.stats.loss_rate.toFixed(1)}% loss rate</span>
                    <span className="capitalize">{pattern.confidence} confidence</span>
                </div>

                <div className="flex items-center gap-2">
                    {pattern.status.is_resolved ? (
                        <span className="inline-flex items-center gap-1 px-2 py-1 rounded text-xs font-medium bg-green-100 text-green-800">
                            <Check size={12} />
                            Resolved
                        </span>
                    ) : pattern.status.is_acknowledged ? (
                        <button
                            onClick={(e) => { e.stopPropagation(); onResolve(); }}
                            className="inline-flex items-center gap-1 px-2 py-1 rounded text-xs font-medium bg-blue-600 text-white hover:bg-blue-700"
                        >
                            <Check size={12} />
                            Resolve
                        </button>
                    ) : (
                        <button
                            onClick={(e) => { e.stopPropagation(); onAcknowledge(); }}
                            className="inline-flex items-center gap-1 px-2 py-1 rounded text-xs font-medium text-blue-600 hover:bg-blue-50"
                        >
                            Acknowledge
                        </button>
                    )}
                </div>
            </div>

            {pattern.detection_count > 1 && (
                <div className="mt-2 text-xs text-gray-500">
                    Detected {pattern.detection_count} times
                </div>
            )}
        </div>
    );
}
